<template>
  <div class="audio-player-music-wave">
    <span />
    <span />
    <span />
    <span />
    <span />
  </div>
</template>

<script>

export default {
  name: 'AudioPlayerMusicWave',
};

</script>

<style lang="scss" scoped>

.audio-player-music-wave{
  position:relative;
}

.audio-player-music-wave span{
  width: 5px;
  height: 5px;
  bottom: 0px;
  position: absolute;
  @apply bg-pink-500;
  animation: bodong 0.5s infinite ease;
}

.audio-player-music-wave span:first-child{
  left: 0px;
  animation-delay: .3s;
}

.audio-player-music-wave span:nth-child(2){
  left: 7px;
  animation-delay: .4s;

}
.audio-player-music-wave span:nth-child(3){
  left: 14px;
  animation-delay: .6s;
}
.audio-player-music-wave span:nth-child(4){
  left: 21px;
  animation-delay: .8s;
}
.audio-player-music-wave span:nth-child(5){
  left: 28px;
  animation-delay: 1s;
}

@-webkit-keyframes bodong{
  0%{height: 5px; background: bule;}
  30%{height: 15px; background: bule;}
  60%{height: 20px; background: bule;}
  80%{height: 15px; background: bule;}
  100%{height: 5px; background: bule;}
}

</style>
